import { Paper } from "@mui/material";
import { useParams } from "react-router-dom";

export default function Supervisors() {
    const { name } = useParams();

    const Block = ({ type, title, children }) => {
        return (
            <div className="text-sm mt-4">
                {type === 1 ? (
                    <p>
                        <span className="font-medium">{title}</span>
                        {children}
                    </p>
                ) : (
                    <>
                        <p className="font-medium">{title}</p>
                        <p>{children}</p>
                    </>
                )}
            </div>
        );
    };

    return (
        <>
            <div className="container mx-auto px-5 mt-5 lg:mt-20 pb-5 lg:pb-20">
                <Paper elevation={3} sx={{ padding: "20px 30px" }}>
                    <div className="text-[20px] font-medium">
                        {name === "Yelena" && "Ахметова Елена Аврельевна"}
                        {name === "Altay" && "Савруков Алтай Саимович"}
                        {name === "Aray" && "Арипбек Арай Сапаркызы"}
                        {name === "Aidynbek" && "Сандыбаев Айдынбек Жумабаевич"}
                    </div>
                    <div className="mt-4">
                        {name === "Yelena" && (
                            <img src="../images/Elena.png" alt={name} />
                        )}
                        {name === "Altay" && (
                            <img src="../images/Altay.png" alt={name} />
                        )}
                        {name === "Aray" && (
                            <img src="../images/Aray.png" alt={name} />
                        )}
                        {name === "Aidynbek" && (
                            <img src="../images/Aidynbek.jpg" alt={name} className="w-[200px]" />
                        )}
                    </div>

                    {name === "Yelena" && (
                        <>
                            <Block type={1} title="Дата рождения:">
                                {" "}
                                17.12.1988
                            </Block>
                            <Block type={1} title="Должность в проекте:  ">
                                Руководитель проекта
                            </Block>

                            <Block
                                type={1}
                                title="Квалификация и направление работы в проекте:  "
                            >
                                Экономист, реализация проекта
                            </Block>
                            <Block type={1} title="Срок занятости в проекте:  ">
                                36 месяцев
                            </Block>
                            <Block type={1} title="Образование:  ">
                                Казахстанский Институт Менеджмента, Экономики и
                                Прогнозирования (KIMEP) <br /> Бакалавр
                                Социальных Наук в Области Государственного
                                Управления по специальности Финансовый
                                Менеджмент
                            </Block>
                            <Block type={1} title="Опыт работы:  ">
                                9 лет
                            </Block>
                            <Block
                                type={2}
                                title="2012–2016 гг I ТОО «Staron Kazakhstan» I Бухгалтер "
                            >
                                Учет и анализ финансовых операций компании.
                                Обеспечение точного и своевременного учета всех
                                финансовых операций, а также подготовка
                                отчетности и документов для внутреннего и
                                внешнего использования. Ведение бухгалтерского и
                                налогового учета;
                                <br />
                                Оформление хозяйственных операций; ведение
                                кассовых операций, контроль кассовой дисциплины.
                            </Block>
                            <Block
                                type={2}
                                title="2016–2019 гг I ТОО «RSM Global» I Аудитор "
                            >
                                Проверка бухгалтерской и финансовой отчетности;
                                оценка и анализ финансовых операций предприятий;
                                консультация в области учета.
                            </Block>
                            <Block
                                type={2}
                                title="2020–2022 гг I ТОО «MOORE Kazakhstan» I Аудитор "
                            >
                                Проведение проверки, оценка финансовой
                                эффективности работы компании. Бухгалтерский
                                консалтинг; независимая инвентаризация активов и
                                обязательств; консультация по актуарным расчетам
                                долгосрочных обязательств.
                            </Block>
                            <Block
                                type={1}
                                title="2022-настоящее время I ТОО «Partner’s Mountain Water Co» I Генеральный Директор"
                            >
                                Полное руководство деятельностью компании в
                                рамках полномочий; организация стабильной работы
                                компании; реализация стратегических задач;
                                координация деятельности компании; назначение
                                заместителей; оперативное решение проблем;
                                участие в формировании бюджета и контроль его
                                выполнения.
                            </Block>
                        </>
                    )}

                    {name === "Altay" && (
                        <>
                            <Block type={1} title="Дата рождения: ">
                                16.06.1976
                            </Block>
                            <Block type={1} title="Должность в проекте: ">
                                {" "}
                                Маркетолог
                            </Block>
                            <Block
                                type={1}
                                title="Квалификация и направление работы в проекте:  "
                            >
                                Специалист по коммерциализации
                            </Block>
                            <Block type={1} title="Срок занятости в проекте:  ">
                                26 месяцев
                            </Block>
                            <Block
                                type={1}
                                title="Роль и функции в реализации проекта:  "
                            >
                                Коммерциализация Проекта
                            </Block>
                            <div className="mt-4 text-sm">
                                <p className="font-medium">
                                    Имеющиеся дипломы, сертификаты,
                                    свидетельства:{" "}
                                </p>
                                <ul className="list-disc list-outside ml-5">
                                    <li>
                                        КазНТУ I 1991-1997. Диплом Горного
                                        Инженера Электро-Механика, Факультет
                                        Автоматики и Систем Управления, Горная
                                        автоматика. Специализация -
                                        Электрификация и автоматизация
                                        промышленных установок и технологических
                                        комплексов. Диплом № ЖБ-II №0113279{" "}
                                    </li>
                                    <li>
                                        Международный центр журналистики
                                        MediaNet – PR квалификация, 2002год
                                    </li>
                                </ul>
                            </div>

                            <Block type={1} title="Образование:  ">
                                Казахский Национальный Технический Университет
                                Факультет Автоматики и Систем Управления, Горная
                                автоматика. Специализация - Электрификация и
                                автоматизация промышленных установок и
                                технологических комплексов
                            </Block>
                            <Block type={1} title="Опыт работы:  ">
                                33 года
                            </Block>
                            <Block
                                type={2}
                                title="1992-1993 гг I Ассоциация Инженерно-технических работников I Техник-конструктор"
                            >
                                Разработка механических узлов, конструирование,
                                технические расчеты, проектирование и
                                составление чертежей.
                            </Block>
                            <Block
                                type={2}
                                title="1997-1998 гг I СП «RSAG Trade LDT» - Milano, Italia I Менеджер по рекламе"
                            >
                                Размещение рекламных материалов в СМИ.
                            </Block>
                            <Block
                                type={2}
                                title="1999-2000 гг I АО «A-Media» Рекламная служба КТК и Караван I Менеджер по рекламе"
                            >
                                Ведение клиентского кейса, составление клиентам
                                медиа-планов для ТВ и газеты. Медиа-сэйлс
                            </Block>
                            <Block
                                type={2}
                                title="2000-2000 гг I ТОО «Проба» I Менеджер по рекламе"
                            >
                                Ведение клиентского кейса, составление клиентам
                                медиа-планов для ТВ и газеты, размещение
                                наружной рекламы, медиа-баинг, работа с продакшн
                                студиями, типографиями
                            </Block>
                            <Block
                                type={2}
                                title="2000 - 2001 гг I ОАО «Банк ТуранАлем» I Главный специалист Управления Маркетинга и Рекламы"
                            >
                                Составление медиа-планов, размещение рекламных
                                материалов в СМИ, медиа-баинг, продакшн. <br />
                                Определение маркетинговых стратегий, определение
                                креативных стратегий. Медиа-планирование,
                                продакшн, PR.
                            </Block>
                            <Block
                                type={2}
                                title="2001 - 2002 гг I ТОО Издательский дом «Алма-Медиа» ОАО КТК I Менеджер по связям с общественностью и PR, медиа-планер"
                            >
                                Антикризисный PR, определение PR политики
                                канала, медиа-планирование для ТВ, радио и
                                газет. Медиа-сэйлс
                            </Block>
                            <Block
                                type={2}
                                title="2002 - 2003 гг I ЗАО «E&Com Invest» I Директор по маркетингу и рекламе"
                            >
                                Определение маркетинговых стратегий, определение
                                креативных стратегий, продвижение брендов,
                                консалтинг дочерних подразделений (пивоваренные
                                заводы, дистрибьюторские компании)
                                Медиа-планирование, продакшн, PR
                            </Block>
                            <Block
                                type={2}
                                title="2003 – 2004 гг I ТОО «PR-management» I Директор по рекламе"
                            >
                                Медиа-планирование, продакшн, PR, медиа-баинг.
                                Определение маркетинговых стратегий компании.
                            </Block>
                            <Block
                                type={2}
                                title="2004 - 2009 гг I ТОО «Advertising Intelligence» - рекламное агентство полного цикла I Управляющий Директор"
                            >
                                Определение маркетинговых стратегий клиентов,
                                определение креативных стратегий для рекламных
                                кампаний. Курирование отдела Медиа-планирования.
                                Курирование отдела по работе с клиентами.
                                Курирование отдела продакшн и PR. Кадровая
                                политика.
                            </Block>
                            <Block
                                type={2}
                                title="2009 - 2015 гг I ByTheWay Creative office – Рекламное агентство полного цикла I Директор Рекламного Агентства"
                            >
                                Определение маркетинговых стратегий клиентов,
                                определение креативных стратегий для рекламных
                                кампаний. Курирование отдела Медиа-планирования.
                                Курирование отдела по работе с клиентами.
                                Курирование отдела продакшн и PR. Кадровая
                                политика.
                            </Block>
                            <Block
                                type={2}
                                title="2015 - 2022 гг I ТОО «Heilsa» - Рекламное агентство полного цикла I CEO"
                            >
                                Определение маркетинговых стратегий клиентов,
                                определение креативных стратегий для рекламных
                                кампаний. Курирование отдела Медиа-планирования.
                                Курирование отдела по работе с клиентами.
                                Курирование отдела продакшн и PR. Кадровая
                                политика.
                            </Block>
                            <Block
                                type={2}
                                title="2022 - 2023 гг I ТОО «BDO Qazaqstan» - международная консалтинговая аудиторская компания I Специалист по маркетингу и таргетированию"
                            >
                                Таргетирование, медиа-планнинг, медиа-баинг, PR.
                                Консалтинг клиентов по рекламным стратегиям.
                            </Block>
                            <Block
                                type={2}
                                title="2023 - по настоящее время I ТОО «Partner’s Mountain Water Co» I Маркетолог"
                            >
                                Маркетинг, таргетирование, медиа-баинг.
                            </Block>
                            <Block type={1} title="Дополнительные достижения: ">
                                Авторская разработка определения ЦА на основе
                                «Пирамиды Маслоу» и основ психотипов целевой
                                аудитории при таргетировании и
                                медиа-планировании.
                            </Block>
                        </>
                    )}

                    {name === "Aray" && (
                        <>
                            <Block type={1} title="Дата рождения: ">
                                23.05.1989
                            </Block>
                            <Block type={1} title="Должность в проекте:  ">
                                Бухгалтер
                            </Block>
                            <Block
                                type={1}
                                title="Квалификация и направление работы в проекте:  "
                            >
                                Бухгалтер
                            </Block>
                            <Block type={1} title="Срок занятости в проекте:  ">
                                36 месяцев
                            </Block>
                            <Block
                                type={1}
                                title="Роль и функции в реализации проекта:  "
                            >
                                Ведение бухгалтерского учета для
                                коммерциализации предлагаемого Проекта
                            </Block>
                            <div className="mt-4 text-sm">
                                <p className="font-medium">
                                    Имеющиеся дипломы, сертификаты,
                                    свидетельства:
                                </p>
                                <ul className="list-disc list-outside ml-5">
                                    <li>Диплом бакалавра ЖБ – Б №0227011</li>
                                </ul>
                            </div>
                            <Block type={1} title="Образование:  ">
                                Казахский Национальный Технический Университет
                                имени К. Сатпаева. Специальность – Бухгалтерский
                                учет и Аудит.
                            </Block>
                            <p className="mt-4 text-sm font-medium">
                                Опыт работы:{" "}
                            </p>
                            <Block
                                type={2}
                                title="2011–2012 гг I Налоговый Комитет по Балхашскому району Алматинской области I Налоговый инспектор"
                            >
                                Отдел взимания, работа с проблемными
                                налогоплательщиками. Отдел учета.
                            </Block>
                            <div className="mt-4 text-sm">
                                <p className="font-medium">
                                    2012–2013 гг I ТОО «БРД Алматы» I Менеджер
                                    по проблемным займам
                                </p>
                                <ul className="list-disc list-outside ml-5">
                                    <li>
                                        Установление контакта с клиентами с
                                        просроченными платежами.
                                    </li>
                                    <li>
                                        Проведение переговоров и разработка
                                        индивидуальных планов погашения
                                        задолженности.
                                    </li>
                                    <li>
                                        Предоставление информации о долге и
                                        условиях его возврата.
                                    </li>
                                    <li>
                                        Систематический сбор и анализ данных о
                                        проблемных займах.
                                    </li>
                                    <li>
                                        Принятие решений о реструктуризации
                                        кредитов и передаче дел на следующий
                                        этап взыскания.
                                    </li>
                                    <li>
                                        Сотрудничество с юридическим отделом,
                                        страховыми компаниями и внешними
                                        коллекторскими агентствами.
                                    </li>
                                    <li>
                                        Минимизация рисков невозврата средств и
                                        сохранение репутации банка.
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-4 text-sm">
                                <p className="font-medium">
                                    2013 – по настоящее время I ТОО «Partner’s
                                    Mountain Water Co» I Бухгалтер
                                </p>
                                <ul className="list-disc list-outside ml-5">
                                    <li>
                                        Ведение бухгалтерского учета согласно
                                        действующему законодательству.
                                    </li>
                                    <li>
                                        Регулярная обработка и учет финансовых
                                        операций, включая выписку и анализ
                                        банковских счетов.
                                    </li>
                                    <li>
                                        Подготовка и сдача налоговой отчетности
                                        в соответствии с требованиями
                                        законодательства.
                                    </li>
                                    <li>
                                        Контроль за правильностью оформления
                                        первичных документов и их соответствием
                                        нормативам.
                                    </li>
                                    <li>
                                        Участие в формировании бюджета, анализ
                                        финансовых показателей и предоставление
                                        рекомендаций по оптимизации расходов.
                                    </li>
                                    <li>
                                        Взаимодействие с аудиторами и
                                        представителями налоговых органов в
                                        случае проведения проверок.
                                    </li>
                                    <li>
                                        Подготовка месячных и годовых финансовых
                                        отчетов для руководства.
                                    </li>
                                    <li>
                                        Обеспечение соблюдения бухгалтерских
                                        стандартов и нормативов.
                                    </li>
                                    <li>
                                        Работа с программами учета и
                                        автоматизированными бухгалтерскими
                                        системами.
                                    </li>
                                    <li>
                                        Поддержание актуальности знаний в
                                        области бухгалтерии и налогообложения.
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}

                    {name === "Aidynbek" && (
                        <>
                            <Block type={1} title="Дата рождения: ">
                                04.07.1988
                            </Block>
                            <Block type={1} title="Должность в проекте:  ">
                                Финансовый риск-менеджер
                            </Block>
                            <Block
                                type={1}
                                title="Квалификация и направление работы в проекте:  "
                            >
                                Специалист по коммерциализации
                            </Block>
                            <Block type={1} title="Срок занятости в проекте:  ">
                                C 01 марта 2025 г. – 31 декабря 2027 г.
                            </Block>
                            <Block
                                type={1}
                                title="Роль и функции в реализации проекта:  "
                            >
                                Коммерциализация Проекта.
                            </Block>
                            <div className="mt-4 text-sm">
                                <p className="font-medium">
                                    Имеющиеся дипломы, сертификаты,
                                    свидетельства:
                                </p>
                                <ul className="list-disc list-outside ml-5">
                                    <li>Диплом Магистра экономики и бизнеса, по специальности «6М050900-Финансы»</li>
                                    <li>Диплом Бакалавра экономики и бизнеса, по специальности «5В050600-Экономика» </li>
                                </ul>
                            </div>
                            <Block type={1} title="Образование:  ">
                                Магистратура Национального Банка Республики Казахстан при Казахском экономическом университете имени Т. Рыскулова
                                Специальность – «6М050900-Финансы»
                                Казахский экономический университет имени Т. Рыскулова
                                Специальность – «5В050600-Экономика»
                            </Block>
                            <p className="mt-4 text-sm font-medium">
                                Опыт работы: 11 лет
                            </p>
                            <Block
                                type={2}
                                title="2013-2019 гг Национальный Банк РК. Главный специалист-экономист Управления регулирования финансового рынка Департамента методологии финансового рынка"
                            >
                                Разработка законопроектов и нормативных правовых актов в области регулирования финансового рынка
                            </Block>
                            <Block
                                type={2}
                                title="2019-2022 гг Агентство РК по регулированию и развитию финансового рынка. Начальник Управления регулирования и развития финансовых организаций Департамента методологии и пруденциального регулирования финансовых организаций"
                            >
                                Разработка законопроектов и нормативных правовых актов в области регулирования финансового рынка
                            </Block>
                            <Block
                                type={2}
                                title="2022 - по настоящее время ИП «AQUILA»"
                            >
                                Формирование стратегических целей и задач по развитию организации
                            </Block>
                        </>
                    )}
                </Paper>
            </div>
        </>
    );
}
